module.exports = __webpack_public_path__ + "img/bn_m(5).cd13bf30.png";